import { Button, Divider, Modal, Switch } from "antd";
import {
  QuestionCircleOutlined,
  SearchOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch, RootState } from "../../../app/store";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import {
  selectTheme,
  setThemeColor,
  showSearchPopup,
  showSupportPopup,
  ThemeColor,
  ThemeMode,
} from "../../../features/theme/themeSlice";
import ProfileMenuContainer from "../../WelcomeLayout2/components/ProfileMenuContainer";
import { useEffect, useState } from "react";
import ProfileMenuContainerInverse from "../../WelcomeLayout2/components/ProfileMenuContainerInverse";
import LanguageSelector from "../../WelcomeLayout2/components/LanguageSelector";
import { PlayerMode, selectPlayer } from "../../../features/player/playerSlice";
import { GraphQLResult, GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { API } from "aws-amplify";
import { AccountMovement, GetMovementsListQuery } from "../../../API";
import { getMovementsList } from "../../../graphql/queries";
import { useIntl } from "react-intl";
import PrintPlacebet from "../../../views/account/components/PrintPlacebet";

type HeaderLinksProps = {
  onUpChevron?: () => void;
  menuInverse?: boolean;
  noshowTicket?: boolean;
};

const HeaderLinks = ({
  onUpChevron,
  menuInverse = false,
  noshowTicket = false
}: HeaderLinksProps) => {
  const [printLastTicket, setPrintlastTicket] = useState<boolean>(false);
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const dispatch = useDispatch<AppDispatch>();
  const [settingMenuVisible, setSettingMenuVisible] = useState<boolean>(false);
  const [lastPlacebetMovement, setLastPlacebetMovement] =
    useState<AccountMovement | null>(null);
  const [modalTicket, setModalTicket] = useState<boolean>(false);
  const intl = useIntl();

  useEffect(() => {
    if (printLastTicket) {
      (async () => {
        try {
          const result: GraphQLResult<GetMovementsListQuery> =
            (await API.graphql({
              query: getMovementsList,
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              variables: {
                username: player.username,
              },
            })) as GraphQLResult<GetMovementsListQuery>;
          const m: Array<AccountMovement> =
            result.data.getMovementsList.items.filter(
              (mv) =>
                mv.provider_hook_event === "PLACEBET" ||
                mv.provider_hook_event === "ATLASBET"
            );
          console.log(result, m);
          setLastPlacebetMovement(m[0]);
          if (m.length > 0) setModalTicket(true);
          else {
            alert("no tickets data");
            setPrintlastTicket(null);
          }
        } catch (e) {
          alert("errore \n" + JSON.stringify(e));
          setPrintlastTicket(null);
        }
      })();
    }
  }, [printLastTicket]);

  return (
    <>
      <ul className="header-links d-flex f-row" style={{ marginLeft: "12px", marginRight:"2px" }}>
        {player.mode === PlayerMode.DEFAULT && (
          <li className="pointer">
            <div
              onClick={() => {
                dispatch(showSupportPopup(true));
              }}
            >
              <QuestionCircleOutlined />
            </div>
          </li>
        )}
        {player.mode !== PlayerMode.KIOSK && (
          <li className="pointer">
            <div
              onClick={() => {
                dispatch(showSearchPopup(true));
              }}
            >
              <SearchOutlined />
            </div>
          </li>
        )}
        <li className="pointer">
          <div
            tabIndex={0}
            onBlur={() => {
              setSettingMenuVisible(false);
            }}
            onClick={() => {
              setSettingMenuVisible(!settingMenuVisible);
            }}
          >
            <SettingOutlined />
          </div>
          {menuInverse && (
            <ProfileMenuContainerInverse
              right={-14}
              visible={settingMenuVisible}
            >
              <LanguageSelector
                onChange={() => {
                  setSettingMenuVisible(false);
                }}
                footer={true}
              />
            </ProfileMenuContainerInverse>
          )}
          {!menuInverse && (
            <ProfileMenuContainer right={-14} visible={settingMenuVisible}>
              <LanguageSelector
                onChange={() => {
                  setSettingMenuVisible(false);
                }}
              />
            </ProfileMenuContainer>
          )}
        </li>
        {/* nascondere ticket freedcamp modifice 31 agosto */}

        {!noshowTicket &&  <li
          className="pointer"
       
          onClick={() => {
            setPrintlastTicket(true);
          }}
        >
       
        {/**   
         {theme.mode === ThemeMode.DEFAULT && (
       <div>
            <img  src="images/ticket.png" style={{ height: "25px" }} alt="" />
          </div> )}
        */}
        </li> }


        {theme.mode === ThemeMode.DEFAULT && (
          <li style={{ paddingBottom: "3px" }}>
            <Switch
              checkedChildren={<FontAwesomeIcon icon={faSun} />}
              unCheckedChildren={<FontAwesomeIcon icon={faMoon} />}
              checked={theme.theme === ThemeColor.light}
              onChange={(value) => {
                const t: ThemeColor = value
                  ? ThemeColor.light
                  : ThemeColor.dark;
                dispatch(setThemeColor(t));
              }}
            />
          </li>
        )}
        {onUpChevron && theme.mode === ThemeMode.DEFAULT && (
          <>
            {!theme.isMobile && (
              <li className="li-divider">
                <Divider orientation="center" type="vertical" />
              </li>
            )}
            {!theme.isMobile && (
              <li
                onClick={() => {
                  onUpChevron && onUpChevron();
                }}
              >
                <FontAwesomeIcon icon={faChevronUp} />
              </li>
            )}
          </>
        )}
      </ul>
      <Modal
        visible={modalTicket}
        title={intl.formatMessage({ id: "print.ticket" })}
        okText="Print "
        cancelText="Cancel"
        onCancel={() => {
          setModalTicket(false);
          setPrintlastTicket(false);
        }}
        onOk={() => {
          (() => {
            const divContents =
              document.getElementById("ticket-print").innerHTML;
            // const a = window.open('', '', 'width=800');
            // a.document.write('<html>');
            // a.document.write(`<head>
            // 	<style>
            // 		img{width:100%;margin-bottom:20px}
            // 		@page {
            // 			margin: 1cm;
            // 			size: letter;
            // 		  }

            // 	table{ border-spacing: 0; width: 100%}
            // 	table th { border: 1px solid black;background:black; color:white }
            // 	table td { border: 1px solid black; }
            // 	</style>
            // </head>`);
            // a.document.write('<body>');
            // a.document.write('<img src="images/logo.png" />');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.print();
            // setTimeout(() => {}, 700);

            function closePrint(this: any) {
              document.body.removeChild(this.__container__);
            }

            function setPrint(this: any) {
              this.contentWindow.__container__ = this;

              this.contentWindow.document.write(
                `<style>
								@media print {
									body { -webkit-print-color-adjust: exact; }
									@page { width:80mm; margin-top: 0; margin-bottom: 0; }
								}
								body {font-size: 1.5em;} table td{border: 1px solid black;padding:4px} table{border-spacing: 0;} img{width:100%; margin-bottom:10px}</style>
								<img src="/images/logo-printer.png" /><br>
								${divContents}`
              );
              this.contentWindow.onbeforeunload = closePrint;
              this.contentWindow.onafterprint = closePrint;
              this.contentWindow.focus(); // Required for IE
              setTimeout(() => {
                this.contentWindow.print();
              }, 700);
            }

            const oHiddFrame = document.createElement("iframe");
            oHiddFrame.onload = setPrint;
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.right = "0";
            oHiddFrame.style.bottom = "0";
            oHiddFrame.style.width = "0";
            oHiddFrame.style.height = "0";
            oHiddFrame.style.border = "0";

            document.body.appendChild(oHiddFrame);
          })();
        }}
      >
        <p id="ticket-print">
          {lastPlacebetMovement && (
            <PrintPlacebet movement={lastPlacebetMovement} />
          )}
        </p>
      </Modal>
    </>
  );
};

export default HeaderLinks;
